import datapoints from '../datapoints';
import mapInboxRuleToInboxRuleClauses from './helpers/mapInboxRuleToInboxRuleClauses';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import { logUsage } from 'owa-analytics';
/**
 * Sets the given rule to edit mode
 * @param inboxRuleId the inbox rule id
 */
export default select({
    listOptionState: function () { return store.inboxRulesListState; },
    editOptionState: function () { return store.inboxRulesEditState; },
})(action('editInboxRule')(function editInboxRule(inboxRuleId, state) {
    var _a = datapoints.editInboxRuleDatapoint.datapoint, eventName = _a.name, customData = _a.customData;
    var listOptionState = state.listOptionState;
    var inboxRule = listOptionState.inboxRules.get(inboxRuleId);
    logUsage(eventName, customData(inboxRule));
    mapInboxRuleToInboxRuleClauses(inboxRule);
}));
//# sourceMappingURL=editInboxRule.js.map